import axios from "axios";

// Base URL from environment variables or default to localhost
const API = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL || "https://wtsdambulla.propcsol.com/", // commented becouse localhos testing
    // baseURL: process.env.REACT_APP_BASE_URL ,
    headers: {
        "Content-Type": "application/json"
    }
});

// Add token automatically if available
API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("authToken"); // Retrieve token from local storage
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Handle API errors globally
API.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error("API Error:", error.response?.data || error.message);
        return Promise.reject(error);
    }
);

export default API;

// Repair API Service
export const getRepairs = async () => API.get("/repairs");
export const getRepairById = async (id) => API.get("/repairs/${id}");
export const createRepair = async (repairData) => API.post("/repairs/create", repairData);
export const addRepairParts = async (repairId, parts) => API.post("/repairs/add-parts", { repairId, parts });
export const completeRepair = async (repairId, laborCharge) => API.post("/repairs/complete", { repairId, laborCharge });
export const markPaymentAsCompleted = async (repairId) => API.post("/repairs/mark-paid", { repairId });